export default {
    breakpoints: {
        xs: 480,
        sm: 768,
        md: 992,
        lg: 1200,
    },
};
